/**
 * MobileMenuToggle.js — кнопка «гамбургер» (три полоски → крестик).
 *
 * Показывается только на узком экране или на страницах игр,
 * когда sidebar спрятан. Клик открывает/закрывает выезжающее меню справа.
 */

import { color_red_default, color_white } from "../../constants/colors";

const MobileMenuToggle = ({ isOpen, onToggle }) => (
  <div
    onClick={onToggle}
    style={{
      width: 32,
      height: 32,
      position: "absolute",
      top: 15,
      right: isOpen ? 260 : 20,
      cursor: "pointer",
      zIndex: 2000,
      borderRadius: "50%",
      backgroundColor: color_white,
      transition: "transform 0.3s",
    }}
  >
    <div
      style={{
        width: 14,
        height: 2,
        borderRadius: 1,
        backgroundColor: color_red_default,
        marginBottom: 2,
        marginTop: 10,
        marginLeft: 9,
        transition: "transform 0.3s",
        transform: isOpen ? "rotate(45deg) translate(3px, 2px)" : "none",
      }}
    />
    <div
      style={{
        width: 14,
        height: 2,
        borderRadius: 1,
        backgroundColor: color_red_default,
        marginBottom: 2,
        marginLeft: 9,
        opacity: isOpen ? 0 : 1,
        transition: "opacity 0.3s",
      }}
    />
    <div
      style={{
        width: 14,
        height: 2,
        marginLeft: 9,
        backgroundColor: color_red_default,
        transition: "transform 0.3s",
        transform: isOpen ? "rotate(-45deg) translate(3px, -3px)" : "none",
      }}
    />
  </div>
);

export default MobileMenuToggle;
